document.getElementById('items-per-page')
    ?.addEventListener('change', async event => {
        const target = event.target as HTMLSelectElement;

        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set('perpage', target.value);

        window.location.search = urlParams.toString();
    });
